<template>
  <div class="tw-p-8 tw-grow tw-flex tw-flex-col tw-items-center tw-gap-20">
    <header class="tw-text-center">
      <h1 class="fontSize2 extraBold crossAxisFlexEnd">
        {{ prospect ? `Values for ${prospect.name}` : 'Your Values' }}
      </h1>

      <h2 class="base1Text extraBold fontSize1AndHalf">
        We've identified the following values as important
      </h2>
    </header>

    <div class="tw-max-w-2xl tw-flex tw-flex-col tw-gap-10">
      <div
        v-for="(screenSet, i) in namedScreenSets"
        :key="i"
        class="tw-flex"
      >
        <div
          class="tw-px-5 tw-flex-none tw-w-40 tw-font-bold tw-text-right"
          :style="{
            borderRight: 'thick solid',
            borderColor: assignedColors[screenSet.issue_name],
            color: assignedColors[screenSet.issue_name]
          }"
        >
          {{ screenSet.issue_name || screenSet.name }}
        </div>

        <div class="tw-px-5 tw-flex tw-flex-col tw-gap-8">
          <div
            v-for="metric in screenSet.metrics"
            :key="metric.metric_description"
            class="tw-border tw-border-black"
          >
            <div class="tw-font-bold">
              {{ metric.info?.name }}
            </div>
            <div class="tw-text-gray-400">
              {{ metric.info?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="prospect"
      class="tw-flex tw-flex-col tw-gap-5"
    >
      <a
        :href="`/ui/advisor/reports/?values_from=${prospect.id}`"
        class="button is-primary"
      >
        View in Report Builder
      </a>

      <a
        v-if="features['Fund Screener']"
        :href="`/advisor-dashboard/fund-screener-v2/?values_from=${prospect.id}`"
        class="button is-primary"
      >
        View in Fund Screener
      </a>

      <a
        v-if="features['Portfolio Builder']"
        :href="`/advisordashboard/portfolio-builder/?values_from=${prospect.id}`"
        class="button is-primary"
      >
        View in Company Screener
      </a>
    </div>

    <div
      v-else
      class="tw-flex tw-flex-col tw-items-center tw-gap-3"
    >
      <div @click="printDebugInfo">
        <p v-if="closingMessage">
          {{ closingMessage }}
        </p>
        <p v-else>
          Your results have been sent to your advisor!
        </p>
      </div>

      <b-button
        class="is-primary"
        @click="reload"
      >
        Retake the questionnaire
      </b-button>
    </div>
  </div>
</template>


<script>
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'ClientPreferenceResults',
  components: {},
  props: {
    context: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    screenSets: {
      type: Array,
      required: true,
    },
    assignedColors: {
      type: Object,
      required: true,
    },
    prospect: {
      type: Object,
      required: false,
      default: null,
    },
    features: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapStores(useAdvisorStore),
    namedScreenSets() {
      // Screen sets where issue_name is not null
      return this.screenSets.filter(screenSet => screenSet.issue_name || screenSet.name);
    },
    closingMessage() {
      // Visitors will not have advisorStore.advisor populated
      // Try to get from visitor context first
      const msg = this.context?.values_picker_message;
      if (msg) return msg;

      // Fallback to advisorStore
      return this.advisorStore?.advisor?.firm?.values_picker_message;
    },
  },
  created() {
    this.$emit('onCreated');
  },
  methods: {
    reload() {
      window.location.reload();
    },
    printDebugInfo() {
      console.log('Advisor Store');
      console.log(this.advisorStore);
      console.log('Visitor Context');
      console.log(this.context);
    },
  },
};
</script>


<style scoped>

</style>
